import { render } from "./Cross.vue?vue&type=template&id=0f26c012&scoped=true"
import script from "./Cross.vue?vue&type=script&lang=js"
export * from "./Cross.vue?vue&type=script&lang=js"

import "./Cross.vue?vue&type=style&index=0&id=0f26c012&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f26c012"]])

export default __exports__